import type { ProductItem } from '../../../product/model/ProductItem';
import type { ProductProcessorInterface } from '../../../product/processor/ProductProcessorInterface';
import type { ProductAttrComputer } from '../../helper/ProductAttrComputer';

export class FixBooleanAttrValueProcessor implements ProductProcessorInterface {
  public invoke(productItem: ProductItem, attrComputer: ProductAttrComputer): boolean | void {
    if (productItem.attributes) {
      for (const entry of Object.entries(productItem.attributes)) {
        const attributeName = entry[0];
        let value = entry[1];
        if (attrComputer.isBooleanType(attributeName) && typeof value === 'string') {
          try {
            value = JSON.parse(value) as boolean; // JSON.parse method turns "false" / "true" to boolean
          } catch (e) {
            console.error(e);
          }
          productItem.setAttrValue(attributeName, value);
        }
      }
    }
  }
}
